// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1ohis","alertIcon":"ConfirmModal_alertIcon__2v7HQ"};